import { render, staticRenderFns } from "./StackedColumnsChart.vue?vue&type=template&id=b2d7dc40"
import script from "./StackedColumnsChart.vue?vue&type=script&lang=js"
export * from "./StackedColumnsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports